/**
 * Watches for dynamically added elements matching a selector.
 * Calls the callback for each new matching element (including children of added nodes).
 */
export const observeNewElements = (
  selector: string,
  callback: (element: Element) => void
): MutationObserver => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        const element = node as Element;
        if (element.matches(selector)) callback(element);
        element.querySelectorAll(selector).forEach(callback);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  return observer;
};
